import { render, staticRenderFns } from "./PowerCodeExplainerContent.vue?vue&type=template&id=5afba358&scoped=true"
import script from "./PowerCodeExplainerContent.vue?vue&type=script&lang=js"
export * from "./PowerCodeExplainerContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afba358",
  null
  
)

export default component.exports